import { takeEvery, call, put } from 'redux-saga/effects';
import actionTypes from 'redux/actionTypes';
import { setFirstTimeUsrStatus, errFirstTimeUsrStatus } from 'components/UserTour/Tour.action';
import APIURLPATH from 'constants/apiconstants';
import { getData } from 'service/getData.service';

export function* getTourSaga(request) {
	try {
		const tourRes = yield call(getData, APIURLPATH.FIRST_TIME_USER, request.payload);
		yield put(setFirstTimeUsrStatus(tourRes));
	} catch (error) {
		yield put(errFirstTimeUsrStatus(505));
	}
}

export function* tourSagaWatcher() {
	yield takeEvery(actionTypes.GET_FIRSTTIME_USR_STATUS, getTourSaga);
}
